import { useQuery } from "@tanstack/react-query";
import { searchProducts } from "../api/endpoints";
import { qk } from "../api/queryKeys";
import { sortSearchResults } from "../utils/searchUtils";
import useDebouncedValue from "./useDebouncedValue";

export default function useSearch(query, { delay = 400 } = {}) {
  const debounced = useDebouncedValue(query.trim(), delay);
  const enabled = debounced.length > 0;

  const result = useQuery({
    queryKey: qk.products.search(debounced),
    queryFn: async ({ signal }) => {
      const data = await searchProducts(debounced, { signal });
      return {
        ...data,
        products: sortSearchResults(data?.products || []),
      };
    },
    enabled,
    staleTime: 60 * 1000,
  });

  return { ...result, debouncedQuery: debounced, enabled };
}
